import {
  ApiErrorHandlingOutcome,
  ParsedApiError,
  apiErrorHasCode,
} from "@jugl-web/rest-api";
import { useTranslations } from "@jugl-web/utils";
import { useCallback } from "react";
import { UseFormSetError } from "react-hook-form";
import { ManageBoardFormValues } from "../types";

export const useBoardValidationErrorHandler = (
  setError: UseFormSetError<ManageBoardFormValues>
) => {
  const { t } = useTranslations();

  return useCallback(
    (error: ParsedApiError): ApiErrorHandlingOutcome => {
      if (error.type !== "http" || error.status !== 400) {
        return "unhandled";
      }
      if (apiErrorHasCode(error, "prefix_already_exists")) {
        setError("prefix", {
          message: t({
            id: "tasks-page.board-with-that-prefix-already-exists",
            defaultMessage: "Board with that prefix already exists",
          }),
        });
      } else {
        setError("name", {
          message: t({
            id: "tasks-page.board-with-that-name-already-exists",
            defaultMessage: "Board with that name already exists",
          }),
        });
      }
      return undefined;
    },
    [setError, t]
  );
};
